var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7532 6.94737H8.93507L9.14286 1.05263C9.14286 0.421053 8.72727 0 8.1039 0C7.68831 0 7.06494 0.421053 7.06494 1.05263L6.85714 6.94737L1.03896 7.15789C0.415584 7.15789 0 7.57895 0 8.21053C0 8.84211 0.415584 9.26316 1.03896 9.26316L6.85714 9.05263L6.64935 14.9474C6.64935 15.5789 7.06493 16 7.68831 16C8.31169 16 8.72727 15.5789 8.72727 14.9474L8.93507 8.8421L14.961 8.63158C15.5844 8.63158 16 8.21053 16 7.57895C15.7922 7.36842 15.3766 6.73684 14.7532 6.94737Z",
    fill: "#808285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1df1c60f545ef7028a07256c4ed51c18.svg";
export { ForwardRef as ReactComponent };